<template>
  <div
    class="sidebar"
    @mouseover="hoverSidebar"
    @mouseleave="hoverOutSidebar"
    :data-color="backgroundColor"
    :data-image="backgroundImage"
    :data-active-color="activeColor"
  >
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <div class="logo">
        <a class="logo-mini" href="/home">
          <div class="logo-img">
            <img :src="logo" alt="logo" class="custom-logo-sidebar" />
          </div>
        </a>
        <br />
        <!-- <a href="" class="simple-text logo-normal">
          {{ getNameCompany.title }}
        </a> -->
      </div>
      <slot> </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            >
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sidebar',
  props: {
    title: {
      type: String,
      default: 'SmartCultivo',
    },
    backgroundColor: {
      type: String,
      default: 'white',
      validator: (value) => {
        let acceptedValues = [
          '',
          'blue',
          'azure',
          'green',
          'orange',
          'red',
          'purple',
          'black',
          'white',
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    backgroundImage: {
      type: String,
      default: '',
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: (value) => {
        let acceptedValues = [
          'primary',
          'info',
          'success',
          'warning',
          'danger',
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      default: '/static/img/Simbolo y logo SmartCurltivo.png',
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
      };
    },
    getNameCompany() {
      return {
        title: this.$store.state.auth.user.business[0].name,
      };
    },
  },
  methods: {
    async initScrollBarAsync() {
      await import('perfect-scrollbar/dist/css/perfect-scrollbar.css');
      const PerfectScroll = await import('perfect-scrollbar');
      PerfectScroll.initialize(this.$refs.sidebarScrollArea);
    },

    hoverSidebar() {
      let logo = document.getElementsByClassName('custom-logo-sidebar');
      if (this.$sidebar.isMinimized) {
        logo[0].style.maxWidth = '110px';
        //logo[0].style.paddingTop = '15px'
      }
    },

    hoverOutSidebar() {
      let logo = document.getElementsByClassName('custom-logo-sidebar');
      if (this.$sidebar.isMinimized) {
        logo[0].style.maxWidth = '58px';
        //logo[0].style.paddingTop = '0px'
      }
    },
  },
  mounted() {
    this.initScrollBarAsync();
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
